<div [class.loading-overlay-container]="overlay()" [class.loading-container]="!overlay()" id="loading-container">
    @if (global()) {
        <img [src]="'images/app-loader.gif'" alt="mouse-loader" id="app-loader-image" />

        <p id="app-loader-text">{{ 'uiKit.miscs.loader.loaderText' | translate }}</p>
    } @else {
        <div [class]="'dot-flashing ckm-dot-flashing'"></div>
    }
</div>
